export default {
  setupProgrammes: "applications/programmes",
  applicationDocument: (id) =>
    `cu/PEGASUS_CU/SchoolManagement_GetApplicationDocument?applicationNo=${id}`,
  admissionLetter: (profileID) =>
    `cu/PEGASUS_CU/SchoolManagement_GetAdmissionLetter?profileID=${profileID}`,
  studentTimetable: (nationalID) =>
    `cu/PEGASUS_CU/SchoolManagement_GetStudentExamTimetable?nationalID=${nationalID}`,
  serviceRequest: (id) => `applications/serviceRequest?no=${id}`,
  applications: (id) => `applications?profileID=${id}`,
  patchApplication: "applications/serviceRequest/patch",
  application: "applications/update",
  proforma: (id) =>
    `cu/PEGASUS_CU/SchoolManagement_getApplicationProformaInvoice?applicationCode=${id}`,
  receipt: (id) =>
    `cu/PEGASUS_CU/SchoolManagement_getReceiptReport?receiptNo=${id}`,
};
